import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AllLabels } from '../../constants/app.constants';
import { UserRegistrationResponse } from '../../domains/common.domain';
import { CommunicationService } from '../../services/communication.service';
import { ErrorService } from '../../services/error/error.service';
import { EnvironmentService } from '../../services/environment.service';
import { ValidationsService } from '../../services/validations.service';
import { SelectItem } from 'primeng';
import { NetzTranslateService } from '../../services/netz-translate.service';

@Component({
  selector: 'app-new-registration',
  styleUrls: ['./new-registration.component.scss'],
  templateUrl: './new-registration.component.html',
})
export class NewRegistrationComponent implements OnInit {
  @Output() changeView: EventEmitter<{ id: number; email?: string }>;

  appLabels: {
    [key: string]: string;
  };
  errorMessage: string;
  isLoading: boolean;
  disableSubmitButton: boolean;
  successMessage: string;
  userFormGroup: FormGroup;
  displayTerms: boolean;
  showPasswordOne: boolean;
  showPasswordTwo: boolean;
  currentLang = this.translateNetz.getCurrentLang();
  roleOptions: SelectItem[] = [
    { label: this.currentLang == 'en' ? 'Technician' : 'Hauptinstallateur', value: 'standard_technician' },
    { label: this.currentLang == 'en' ? 'Guest Technician' : 'Gastinstallateur', value: 'guest_technician' },
  ];

  constructor(
    private communicationService: CommunicationService,
    private errorService: ErrorService,
    private translateNetz: NetzTranslateService,
    public environmentService: EnvironmentService
  ) {
    this.changeView = new EventEmitter<{ id: number; email?: string }>();
  }

  ngOnInit(): void {
    this.appLabels = AllLabels.app;
    this.disableSubmitButton = true;
    this.errorMessage = '';
    this.successMessage = '';
    this.isLoading = false;
    this.showPasswordOne = false;
    this.showPasswordTwo = false;

    if (!this.environmentService.technicianRegistrationHideCustomerRoleOption) {
      this.roleOptions.push({ label: this.currentLang == 'en' ? 'Customer' : 'Kunde', value: 'customer' });
    }

    this.prepareForm();
  }

  submitFormData(): void {
    if (this.userFormGroup.valid && !this.disableSubmitButton) {
      const dataObject = [
        {
          email: this.userFormGroup.value.email,
          role: this.userFormGroup.value.role,
        },
        {
          password: this.userFormGroup.value.password,
        },
      ];
      const requestData = {
        registration: dataObject,
      };

      this.isLoading = true;
      const subscription = this.communicationService.loginPostData('registration', requestData);
      subscription.subscribe(
        (response: HttpResponse<any>) => {
          this.errorService.throwErrorIfFailure(response, false, this.errorHandler);

          if ((response.body as UserRegistrationResponse).status === '02') {
            this.errorMessage = 'app.user-form.registration-user-exists';
            this.successMessage = '';
          } else {
            this.errorMessage = '';
            this.successMessage = 'app.user-form.registration-success';
          }
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          if (error.status === 422) {
            this.errorMessage = error.error.message;
          } else if (error.error.status === '02') {
            this.errorMessage = 'app.user-form.registration-user-exists';
            this.successMessage = '';
          } else {
            this.errorService.throwErrorIfFailure(error, true);
          }
        }
      );
    }
  }

  showLoginForm(): void {
    this.changeView.emit({ id: 0 });
  }

  showTerms(): void {
    this.displayTerms = true;
  }

  closeDialog() {
    this.communicationService.dashboardLogoClick(false);
  }

  errorHandler = (): void => {
    this.isLoading = false;
  };

  private prepareForm(): void {
    this.userFormGroup = new FormGroup({
      email: new FormControl('', [ValidationsService.emailValidator(), Validators.required]),
      password: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required]),
      role: new FormControl(null, [Validators.required]),
      acceptPolicy: new FormControl(false, [Validators.required]),
    });

    this.userFormGroup.valueChanges.subscribe(values => {
      this.errorMessage = '';
      this.successMessage = '';
      if (this.userFormGroup.valid) {
        this.disableSubmitButton = values.password !== values.confirmPassword || !values.acceptPolicy;
      } else {
        this.disableSubmitButton = true;
      }
    });
  }
}
